module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "right-box resizable",
    style: ({
      width: width + 'px'
    }),
    on: {
      "click": function($event) {
        $emit('click')
      }
    }
  }, [_h('resizer', {
    attrs: {
      "type": "vertical"
    },
    on: {
      "resizer:begin": onResizeBegin,
      "resizer:resize": onResize
    }
  }), " ", _h('div', {
    staticClass: "box-header"
  }, [_m(0), " ", _h('span', {
    staticClass: "box-caret glyphicon glyphicon-menu-right",
    on: {
      "click": function($event) {
        $emit('symbol-table:close')
      }
    }
  })]), " ", _h('div', {
    staticClass: "box-body"
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (symbols.length < 1),
      expression: "symbols.length < 1"
    }],
    staticClass: "placeholder"
  }, ["Nothing to show"]), " ", _h('ul', {
    staticClass: "list",
    attrs: {
      "id": "symbol-list"
    }
  }, [_l((symbols), function(symbol) {
    return [_h('li', {
      attrs: {
        "data-bind": "attr: {id: attrId}, css: {active: isActive}, event: {click: $parents[0].setActive.bind($data), dblclick: toggle}"
      }
    }, [_m(1), " ", _h('span', [_s(symbol.name)]), " ", _h('span', {
      staticClass: "extra",
      attrs: {
        "data-bind": "text: rowText"
      }
    }, ["type: " + _s(symbol.type || 'unknown') + ", occurance: " + _s(symbol.positions.length)])]), " ", _l((symbol.positions), function(position, $index) {
      return _h('li', {
        staticClass: "position-row",
        attrs: {
          "data-bind": "text: rowText, visible: $parents[0].isOpen, css: {active: isActive}, click: $parents[1].setActive.bind($data)"
        }
      }, ["\n          [" + _s($index + 1) + "] line: " + _s(position.first_row) + ", ch: " + _s(position.first_col) + "\n        "])
    }), " "]
  })])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "box-title"
  }, ["Symbol Table"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon li-caret",
    attrs: {
      "data-bind": "css: {'glyphicon-triangle-right': !isOpen(), 'glyphicon-triangle-bottom': isOpen}, click: toggle"
    }
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ceec9ee0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SymbolTable.vue
 ** module id = 138
 ** module chunks = 2
 **/